<!-- 开启单场观看后，如果第二次再次进入观看直播，提示该限制观看弹框 -->
<template>
    <el-dialog title="" :visible.sync="dialogVisible" width="295px" :custom-class="'limit-watch-dialog'" :show-close="false" :close-on-click-modal="false">
        <p class="tips">此直播间为一次性体验，您已观看完毕。感谢您的参与，期待下次相遇~</p>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false
            }
        },
        methods: {
            show() {
                this.dialogVisible = true
            }
        }
    }
</script>

<style>
.el-dialog.limit-watch-dialog {
    width: 295px;
    height: 234px;
    margin-top: 30vh !important;
    background-color: transparent;
    background-size: 100% 100%;
    background-image: url(../assets/imgs/liveDialog/single_watch_dialog_bg.png);
}
.el-dialog.limit-watch-dialog .tips {
    font-size: 16px;
    color: #1872ed;
    margin-top: 40px;
    letter-spacing: 1px;
    line-height: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/limitWatchDialog.vue